import {
  NuvemEnvioCreateDispatchesRequestDto,
  NuvemEnvioCreateDispatchesResponseDto,
} from '@tiendanube/common';
import axios from 'App/axios';

const createNuvemEnvioLabels = async (
  payload: NuvemEnvioCreateDispatchesRequestDto,
): Promise<NuvemEnvioCreateDispatchesResponseDto> => {
  const { data } = await axios.post('nuvem-envio/dispatches', payload);
  return data;
};

export default {
  createNuvemEnvioLabels,
};
